<template>
  <div id="social">
    <span v-if="streamStatus.stream != null">
      <div class="badge"></div>
      <a href="//twitch.tv/niller2005" target="_blank">
        <icon :icon="['fab', 'twitch']" />
      </a>
    </span>
    <a v-else href="//twitch.tv/niller2005" target="_blank">
      <icon :icon="['fab', 'twitch']" />
    </a>
    <a href="//twitter.com/niller2005" target="_blank">
      <icon :icon="['fab', 'twitter']" />
    </a>
    <a href="//github.com/niller2005" target="_blank">
      <icon :icon="['fab', 'github']" />
    </a>
    <a href="//bitbucket.org/niller2005" target="_blank">
      <icon :icon="['fab', 'bitbucket']" />
    </a>
    <a href="//patreon.com/niller2005" target="_blank">
      <icon :icon="['fab', 'patreon']" />
    </a>
  </div>
</template>

<script>
import TwitchStatus from "@/services/TwitchStatus";

function getTwitchStatus () {
  return TwitchStatus.getStreamStatus("niller2005");
}

export default {
  name: 'Social',
  data () {
    return {
      streamStatus: {}
    };
  },
  async mounted () {
    let res = await getTwitchStatus();
    this.streamStatus = res.data;
  },
};
</script>

<style lang="scss" scoped>
#social {
  font-family: "Roboto", sans-serif;
  color: rgba(224, 224, 224, 0.72);
  font-size: 3vmin;
  a {
    @extend #social;
    line-height: 1.5em;
    margin: auto 0.3em;
    text-decoration: none;
    &:hover {
      color: #e0e0e0;
    }
    &:focus {
      color: #e0e0e0;
      outline: none;
    }
  }
  .badge {
    width: 1.2vmin;
    height: 1.2vmin;
    background: red;
    border-radius: 100%;
    position: absolute;
    left: 3.05vmin;
  }
}
</style>
